<template>
<div :cn="componentName" class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>

<div class="flex overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-start md:inset-0 h-modal sm:h-full" id="delete-modal">
    <div class="relative px-4 w-full max-w-md h-full md:h-auto mx-auto mt-16">
        <!-- Modal content -->
        <div class="relative bg-white rounded-md shadow dark:bg-gray-700">
            <!-- Modal header -->
            <div class="flex justify-end p-2">
                <button type="button" @click="$emit('deletemodal:close')" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-md text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </button>
            </div>
            <!-- Modal body -->
            <div class="px-6 pb-4 pt-0">
                <div class="text-center">
                <i class="fas fa-exclamation-circle text-5xl mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-slate-100"></i>
                <h3 class="mb-8 text-base font-normal text-gray-500 dark:text-slate-100">{{ __('labels.basics.delete.question') }}</h3>
                </div>
                <div class="text-right">
                    <custom-button
                    predefinedStyle="transparent"
                    @click="$emit('deletemodal:close')"
                    >
                    <template v-slot:label>
                        {{ __('labels.basics.deleteModal.cancel') }}
                    </template>
                    </custom-button>

                    <custom-button
                    predefinedStyle="red"
                    css="ml-4"
                    @click="$emit('deletemodal:submit', this.deleteProps)"
                    >
                    <template v-slot:label>
                        {{ __('labels.basics.deleteModal.confirm') }}
                    </template>
                    </custom-button>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>

export default {
    props: {
        deleteProps:Object,
    },
    data() {
        return {

        };
    },
    mounted() {
    },
    computed: {
        componentName() {
            return "DeleteModal";
        },
    },
    watch: {
    },
    methods: {
    }
};
</script>
